// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"f52fd0a1","686":"eb994bea","908":"32cbd00e"}[chunkId] + ".chunk.js";
};